import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_AccommodationpreparationListComponent from "../components/_FM_accommodationpreparation/_FM_AccommodationpreparationListComponent";
import _FM_AccommodationpreparationFormComponent from "../components/_FM_accommodationpreparation/_FM_AccommodationpreparationFormComponent";
import _FM_AccommodationpreparationShowComponent from "../components/_FM_accommodationpreparation/_FM_AccommodationpreparationShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_AccommodationpreparationPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action} = useParams();

  useEffect(() => {
    document.title = t('accommodationpreparation') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/accommodation-preparation')
  }, []);

  return (
    <div className="_FM_AccommodationpreparationPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/accommodation-preparation"}/>
      <Panel>
        <_FM_AccommodationpreparationListComponent />
      </Panel>
      <Sidebar position="right" visible={action === 'create' || action === 'update'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate(-1)
               }}>
        <_FM_AccommodationpreparationFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={id && action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate(-1)
               }}>
        <_FM_AccommodationpreparationShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_AccommodationpreparationPage);
